
import "./App.css"
import Weater from "./componants/Weater.jsx";

function App() {
 
  return (
    <> 
    <Weater/>
    </>
  );
}

export default App;

